import { createSelector } from 'reselect';

const selectPolicyDomain = (state) => state.policy;

export const selectOverridableErrors = () =>
    createSelector(selectPolicyDomain, (substate) => {
        return substate.overridableErrors;
    });
